// The app's banners (toasts): one shared store (@jkast90/kast-common/ui),
// shown by <Banner /> in the nav bar and in the dialogs. Settings'
// "Auto-dismiss banner messages" is read each time a banner shows, from the
// same "autoDismissBanners" key as before.

import {
  createBannerStore,
  useBanner as useSharedBanner,
} from "@jkast90/kast-common/ui";

export const AUTO_DISMISS_KEY = "autoDismissBanners";

export const banners = createBannerStore({
  autoDismiss: () => {
    try {
      return localStorage.getItem(AUTO_DISMISS_KEY) !== "false";
    } catch {
      return true; // storage blocked: the default
    }
  },
});

/** The app's banners: showSuccess, showError, showBanner and the rest. */
export const useBanner = () => useSharedBanner(banners);
